import React, {useEffect, useState} from 'react';
import {useForm} from "react-hook-form";
import {ToastContainer} from "react-toastify";
import axiosConfig from "./utils/axiosConfig";
import 'react-toastify/dist/ReactToastify.css';
import {notify} from "./utils/utils";
import ReCAPTCHA from 'react-google-recaptcha'
import HeaderSubPageTiny from "./partial/HeaderSubPageTiny";
import {useSearchParams} from "react-router-dom";

const NewsletterSubscribe = ({partner}) => {
    const {
        reset,
        trigger,
        register,
        handleSubmit,
        formState: {errors},
    } = useForm()

    const [isLoading, setIsLoading] = useState(false);
    //const reCaptchaRef = useRef(null);
    const reCaptchaRef = React.createRef();
    const [searchParams] = useSearchParams();
    const signupMethod = searchParams.get("signup_method");
    const signupSource = searchParams.get("signup_source");

    const sendEmail = async (data) => {
        try {
            const response = await axiosConfig.post('/newsletter/subscription', data,
                {'Content-Type': 'application/json'});
            reset();
            notify(response?.data?.message || "Vielen Dank, dass Sie sich für unseren Newsletter angemeldet haben! In Kürze erhalten Sie eine E-Mail zur Bestätigung Ihrer Anmeldung.", "success")
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            notify(error?.response?.data?.message)
        }
    }

    const onSubmit = async (data, event) => {
        setIsLoading(true);

        // reCaptcha
        event.preventDefault()
        // const captchaValue = reCaptchaRef.current.getValue()
        const captchaValue = await reCaptchaRef.current.executeAsync();
        if (!captchaValue) {
            notify("Bitte versuchen sie es erneut!")
            setIsLoading(false);
            return;
        }

        data["reCaptchaToken"] = captchaValue;
        trigger().then((check) => {
            //console.log(data)
            if (check) {
                sendEmail(data);
            }
        })
    };

    useEffect(() => {
        // reCaptchaRef.current.execute();
        document.title = `${partner?.name} - Newsletter Anmeldung`;
    }, [register, partner])

    return (
        <div>
            <ToastContainer/>
            <div className="site wrapper-content">
                <HeaderSubPageTiny title={'Newsletter Anmeldung'}></HeaderSubPageTiny>
                {partner?.agency_no ? (
                    <section className="content-area">
                        <div className="container">
                            <div className="row">
                                <div className="site-main col-lg-8  col-sm-12 aligncenter">
                                    <div className="pages_content">
                                        <h1 className="post_list_title">
                                            <span><strong>Newsletter Anmeldung</strong></span>
                                        </h1>
                                        <div className="contact_infor">
                                            <p>
                                                Entdecken Sie die Welt mit uns: Ob aufregende neue
                                                Reiseziele, nützliche Tipps zur Reisesicherheit oder spannende
                                                kulturelle
                                                Veranstaltungen wie Ausstellungen und Konzerte – wir halten Sie immer
                                                bestens informiert. Abonnieren Sie unseren kostenlosen Newsletter und
                                                erhalten Sie regelmäßig die neuesten Updates direkt in Ihr Postfach. Sie
                                                können den Service jederzeit bequem über einen Link im Newsletter
                                                abbestellen.
                                            </p>
                                            <hr/>
                                        </div>
                                    </div>

                                    <div className="wpb_wrapper pages_content">
                                        <div role="form">
                                            <div className="screen-reader-response"></div>
                                            <form onSubmit={handleSubmit(onSubmit)}
                                                  noValidate="novalidate">
                                                <div className="form-contact">
                                                    <div className="mt-3">
                                                        <small className="text-muted">
                                                            <span className="text-danger">*</span> Pflichtfelder
                                                        </small>
                                                    </div>
                                                    <div className="row">
                                                        <div className="form-group mb-3 mb-3">
                                                            <input type="hidden" name="agency_no"
                                                                   value={partner.agency_no}
                                                                   {...register(`agency_no`)}/>
                                                            <input type="hidden" name="signup_source"
                                                                   value={signupSource}
                                                                   {...register(`signup_source`)}/>
                                                            <input type="hidden" name="signup_method"
                                                                   value={signupMethod}
                                                                   {...register(`signup_method`)}/>

                                                            <fieldset>
                                                                <legend className="d-none">Newsletter und Neuigkeiten
                                                                    von
                                                                    GLOBALIS
                                                                </legend>
                                                                <input id="accept" className="form-check-input"
                                                                       aria-labelledby="l-accept"
                                                                       aria-invalid={errors.accept ? "true" : "false"}
                                                                       aria-describedby={errors.accept ? "e-accept" : ""}
                                                                       type="checkbox"
                                                                       name={'accept'}
                                                                       {...register(`accept`, {required: true})}/>
                                                                <label className="form-check-label" htmlFor="accept"
                                                                       id="l-accept"><span
                                                                    className="text-danger">*</span>
                                                                    Ja, bitte informieren Sie mich in Zukunft mit
                                                                    Ihrem
                                                                    Newsletter
                                                                    über
                                                                    aktuelle Angebote und Neuigkeiten von GLOBALIS.
                                                                    (Eine
                                                                    Abmeldung
                                                                    ist
                                                                    jederzeit möglich.)
                                                                </label>
                                                            </fieldset>

                                                            {errors?.accept &&
                                                                <p id="e-accept" className="error"><b>Fehler:</b> Bitte
                                                                    Häkchen in der Checkbox
                                                                    setzen.</p>}
                                                        </div>
                                                        <div className="form-group mb-3">
                                                            <label id="l-gender" htmlFor="gender">Anrede</label>
                                                            <select id="gender" className="form-control"
                                                                    aria-labelledby="l-gender"
                                                                    {...register(`gender`, {required: false})}
                                                            >
                                                                <option value="">Bitte wählen</option>
                                                                <option value="Frau">Frau</option>
                                                                <option value="Herr">Herr</option>
                                                            </select>
                                                        </div>

                                                        <div className="form-group mb-3">
                                                            <label id="l-firstname" htmlFor="firstname">Vorname</label>
                                                            <input id="firstname"
                                                                   className="form-control"
                                                                   aria-labelledby="l-firstname"
                                                                   {...register(`firstname`, {required: false})}
                                                            />
                                                        </div>

                                                        <div className="form-group mb-3">
                                                            <label id="l-lastname" htmlFor="lastname">Nachname</label>
                                                            <input
                                                                id="lastname"
                                                                className="form-control" aria-labelledby="l-lastname"
                                                                {...register(`lastname`, {required: false})}
                                                            />
                                                        </div>

                                                        <div className="form-group mb-3">
                                                            <label id="l-email" htmlFor="email">Email<span
                                                                className="text-danger">*</span></label>
                                                            <input
                                                                id="email"
                                                                className="form-control"
                                                                aria-labelledby="l-email"
                                                                aria-invalid={errors.email ? "true" : "false"}
                                                                aria-describedby={errors.email ? "e1-email" : errors.email?.message ? "e2-email" : ""}
                                                                {...register(`email`, {
                                                                    required: true,
                                                                    pattern: {
                                                                        value: /\S+@\S+\.\S+/,
                                                                        message: "Die eingegebene E-Mail stimmt nicht mit dem E-Mail-Format überein",
                                                                    },
                                                                })}
                                                            />

                                                            {errors?.email &&
                                                                <p id="e1-email" className="error"><b>Fehler:</b> E-Mail
                                                                    ist
                                                                    ein Pflichtfeld</p>}

                                                            {errors?.email?.message &&
                                                                <p id="e2-email" className="error">
                                                                    <b>Fehler:</b> {errors.email.message}</p>}
                                                        </div>

                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="form-group mb-3">
                                                                <input id="defaultCheck1" className="form-check-input"
                                                                       aria-labelledby="l-accept2"
                                                                       aria-invalid={errors.accept2 ? "true" : "false"}
                                                                       aria-describedby={errors.accept2 ? "e-accept2" : ""}
                                                                       type="checkbox"
                                                                       {...register(`accept2`, {required: true})}/>
                                                                <label id="l-accept2" className="form-check-label"
                                                                       htmlFor="defaultCheck1"><span
                                                                    className="text-danger">*</span>
                                                                    Ich stimme der Verarbeitung meiner Daten gemäß
                                                                    der <a
                                                                        href="/datenschutz"
                                                                        target="_blank">Datenschutzerklärung</a> zu.
                                                                </label>
                                                                {errors?.accept2 &&
                                                                    <p id="e-accept2" className="error">
                                                                        <b>Fehler:</b> Zustimmung zur Datenverarbeitung
                                                                        erforderlich.</p>}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div>
                                                        {isLoading ? (
                                                            <button type="submit"
                                                                    className="btn btn-primary talign-center disabled">
                                                                <i
                                                                    className="fa fa-spinner"></i> Newsletter
                                                                abonnieren
                                                            </button>
                                                        ) : (
                                                            <button type="submit"
                                                                    className="btn btn-primary talign-center ">Newsletter
                                                                abonnieren
                                                            </button>)}
                                                    </div>

                                                    <ReCAPTCHA
                                                        ref={reCaptchaRef}
                                                        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                                                        size="invisible"
                                                    />
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                ) : (
                    <div className="d-flex justify-content-center align-items-center" style={{minHeight: "60vh"}}>
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default NewsletterSubscribe;